import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { TranslocoPipe } from '@jsverse/transloco';

import { LanguageCode, LanguageService } from '../../../../../../../../shared/modules/language/services/language.service';
import { MainNavLanguageFlagComponent } from '../main-nav-language-flag/main-nav-language-flag.component';

@Component({
  selector: 'sh-main-nav-languages',
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    TranslocoPipe,
    MatMenuModule,
    MatIconModule,
    MainNavLanguageFlagComponent
  ],
  templateUrl: './main-nav-languages.component.html',
  styleUrl: './main-nav-languages.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainNavLanguagesComponent {
  constructor(public languageService: LanguageService) {}

  chooseLanguage(languageCode: LanguageCode) {
    this.languageService.changeLanguage(languageCode).then(() => {});
  }
}
